{
  "page": {
    "title": "Opérations commerciales",
    "subtitle": "Analyses du GMV, de la production et des prévisions"
  },
  "tabs": {
    "dashboard": "Tableau de bord",
    "comparison": "Comparaison de produits",
    "forecast": "Prévision"
  },
  "range": {
    "label": "Plage de mois",
    "trigger": "Sélectionner la plage de mois",
    "from": "Du",
    "to": "Au",
    "apply": "Appliquer",
    "cancel": "Annuler",
    "invalid": "« Du » doit être antérieur ou égal à « Au »",
    "monthAria": "Sélectionner le mois"
  },
  "freshness": {
    "ready": "Données au {{when}}",
    "stale": "Les données peuvent être obsolètes — dernier calcul {{when}}",
    "bootstrapping": "Préparation initiale des analyses. Les chiffres apparaîtront sous peu.",
    "recomputing": "Recalcul des analyses — données au {{when}}",
    "unknown": "Fraîcheur des données inconnue"
  },
  "cardState": {
    "loading": "Chargement…",
    "bootstrapping": "Ce rapport est encore en préparation.",
    "empty": "Aucune donnée dans la plage sélectionnée.",
    "insufficient": "Données insuffisantes pour un calcul fiable.",
    "error": "Impossible de charger cette section.",
    "retry": "Réessayer"
  },
  "sectionNav": {
    "label": "Aller à la section",
    "tiles": "Aperçu",
    "weekly": "GMV hebdomadaire",
    "channel": "Répartition par canal",
    "status": "Répartition par statut",
    "pivot": "Tableau croisé des statuts",
    "products": "Meilleurs produits",
    "refund": "Taux de remboursement",
    "variants": "Meilleures variantes",
    "factories": "Usines",
    "production": "Production",
    "regions": "Régions",
    "dataQuality": "Qualité des données"
  },
  "dashboard": {
    "title": "Tableau de bord des opérations",
    "statTiles": {
      "platformGmv": "GMV de la plateforme",
      "orders": "Commandes",
      "items": "Articles",
      "avgOrderValue": "Valeur moyenne de commande",
      "gmvTooltipAria": "À propos du GMV de la plateforme",
      "gmvFormulaTitle": "GMV de la plateforme",
      "gmvFormulaBody": "Somme des totaux des commandes payées sur tous les canaux dans la plage sélectionnée.",
      "gmvDiffersNote": "Diffère du GMV attribué dans le Rapport GMV."
    },
    "weeklyGmv": {
      "title": "GMV hebdomadaire",
      "subtitle": "{{current}} contre {{previous}}",
      "xAxisLabel": "Semaine ISO",
      "weekTick": "S{{week}}",
      "legendCurrent": "{{year}}",
      "legendPrevious": "{{year}}",
      "legendPartial": "Semaine en cours (partielle)",
      "priorYearEmptyNote": "Aucune donnée de {{year}} à comparer."
    }
  },
  "channel": {
    "normal": "Normal",
    "sample": "Échantillon",
    "tiktok": "TikTok"
  },
  "status": {
    "Open": "Ouvert",
    "Paid": "Payé",
    "Unpaid": "Impayé",
    "Pending": "En attente",
    "Processing": "En traitement",
    "InProduction": "En production",
    "Shipped": "Expédié",
    "Delivered": "Livré",
    "Completed": "Terminé",
    "Cancelled": "Annulé",
    "Refunded": "Remboursé",
    "PartiallyRefunded": "Partiellement remboursé",
    "OnHold": "En suspens",
    "Failed": "Échoué"
  },
  "channelMix": {
    "title": "GMV par canal",
    "sharePct": "{{pct}} %",
    "orders": "{{count}} commandes",
    "empty": "Aucune donnée de canal dans la plage sélectionnée.",
    "loadingAria": "Chargement de la répartition par canal",
    "figureAria": "Part du GMV par canal"
  },
  "statusMix": {
    "orderTitle": "GMV par statut de commande",
    "paymentTitle": "GMV par statut de paiement",
    "orders": "{{count}} commandes",
    "empty": "Aucune donnée de statut dans la plage sélectionnée.",
    "loadingAria": "Chargement de la répartition par statut",
    "orderFigureAria": "GMV par statut de commande",
    "paymentFigureAria": "GMV par statut de paiement"
  },
  "statusPivot": {
    "title": "Statut de commande × statut de paiement",
    "caption": "GMV par statut de commande et statut de paiement",
    "rowHeader": "Statut de commande",
    "empty": "Aucune donnée de tableau croisé dans la plage sélectionnée.",
    "loadingAria": "Chargement du tableau croisé des statuts",
    "cellTitle": "{{order}} · {{payment}} : {{gmv}} ({{count}} commandes)"
  },
  "topProducts": {
    "title": "Meilleurs produits par chiffre d'affaires",
    "sortBy": "Trier par {{column}}",
    "columns": {
      "product": "Produit",
      "revenue": "Chiffre d'affaires",
      "qty": "Qté",
      "orders": "Commandes"
    }
  },
  "factories": {
    "title": "Usines",
    "unmapped": "Pays non renseigné",
    "expandRow": "Afficher le détail de {{vendor}}",
    "collapseRow": "Masquer le détail de {{vendor}}",
    "columns": {
      "vendor": "Fournisseur",
      "country": "Pays",
      "gmv": "GMV",
      "products": "Produits",
      "orders": "Commandes",
      "medianProduction": "Production médiane"
    },
    "drilldown": {
      "empty": "Aucun produit pour ce fournisseur dans la plage sélectionnée.",
      "insufficient": "Insuffisant",
      "hours": "{{value}} h",
      "columns": {
        "product": "Produit",
        "orders": "Commandes",
        "qty": "Qté",
        "medianProduction": "Production médiane"
      }
    }
  },
  "production": {
    "title": "Performance de production",
    "colProduct": "Produit",
    "colOrders": "Commandes",
    "colApproval": "Approbation médiane",
    "colProduction": "Production médiane",
    "colItemsPerOrder": "Articles / commande",
    "hours": "{{value}} h",
    "insufficient": "Insuffisant ({{n}})",
    "insufficientTooltip": "Moins de 5 échantillons — médiane masquée."
  },
  "refund": {
    "title": "Taux de remboursement / renvoi",
    "colProduct": "Produit",
    "colMonth": "Mois",
    "colRate": "Taux",
    "colAmount": "Montant remboursé",
    "monthOverrideLabel": "Mois",
    "monthAll": "Tous les mois",
    "flaggedSr": "Au-dessus du seuil de {{threshold}}"
  },
  "regions": {
    "title": "Régions d'expédition",
    "byCountry": "Par pays",
    "byState": "Par région",
    "legendGmv": "GMV",
    "legendOrders": "Commandes",
    "tooltipGmv": "GMV :",
    "tooltipOrders": "{{count}} commandes"
  },
  "topVariants": {
    "title": "Meilleures variantes",
    "productLabel": "Sélectionner un produit",
    "productPlaceholder": "Choisir un produit",
    "axisRevenue": "Chiffre d'affaires",
    "noVariants": "Aucune variante pour ce produit."
  },
  "pagination": {
    "summary": "Page {{page}} sur {{totalPages}} · {{total}} au total",
    "prev": "Précédent",
    "next": "Suivant"
  },
  "state": {
    "refreshing": "Actualisation…"
  },
  "actions": {
    "retry": "Réessayer"
  },
  "comparison": {
    "placeholder": "La comparaison de produits sera bientôt disponible.",
    "periodA": "Période A",
    "periodB": "Période B",
    "periodAAria": "Sélectionner la période A",
    "periodBAria": "Sélectionner la période B",
    "kindAria": "Type de période",
    "versus": "vs",
    "quarterLabel": "T{{quarter}} {{year}}",
    "kind": {
      "month": "Mois",
      "quarter": "Trimestre"
    },
    "matched": {
      "title": "Produits communs",
      "subtitle": "Produits présents dans les deux périodes, avec l'évolution par indicateur.",
      "columns": {
        "product": "Produit",
        "ordersA": "Commandes {{period}}",
        "ordersB": "Commandes {{period}}",
        "deltaOrders": "Δ Commandes",
        "itemsA": "Articles {{period}}",
        "itemsB": "Articles {{period}}",
        "deltaItems": "Δ Articles",
        "refundA": "Remb. {{period}}",
        "refundB": "Remb. {{period}}",
        "deltaRefund": "Δ Remb."
      },
      "deltaUp": "en hausse",
      "deltaDown": "en baisse",
      "deltaFlat": "inchangé"
    },
    "changed": {
      "title": "Produits ajoutés et retirés",
      "subtitle": "Produits présents dans une seule période.",
      "newIn": "Nouveau dans {{period}}",
      "droppedAfter": "Retiré après {{period}}",
      "columns": {
        "product": "Produit",
        "status": "Statut",
        "orders": "Commandes",
        "items": "Articles",
        "refund": "Taux de remboursement"
      }
    },
    "bySupplier": {
      "title": "Par fournisseur",
      "subtitle": "Produits ajoutés et retirés par fournisseur.",
      "none": "—",
      "columns": {
        "supplier": "Fournisseur",
        "newCount": "Ajoutés",
        "droppedCount": "Retirés",
        "newProducts": "Produits ajoutés",
        "droppedProducts": "Produits retirés"
      }
    }
  },
  "forecast": {
    "placeholder": "La prévision sera bientôt disponible.",
    "title": "Prévision {{targetYear}}",
    "subtitle": "Bandes de saisonnalité, projection par cohorte et recommandation S2 vs {{prevYear}}.",
    "degradeBanner": "Historique de l'année précédente insuffisant pour un graphique en éventail de saisonnalité. Affichage de la projection par cohorte uniquement.",
    "fanChart": {
      "title": "Prévision de saisonnalité",
      "subtitle": "Bandes amorties ({{targetYear}}) vs réel",
      "actualLegend": "Réel",
      "band100": "Saisonnalité 100%",
      "band50": "Amortie 50%",
      "band25": "Amortie 25%",
      "empty": "Aucune donnée de saisonnalité disponible.",
      "xAxisLabel": "Mois"
    },
    "cohort": {
      "title": "Projection par cohorte et canal",
      "subtitle": "GMV S2 projeté : {{value}}",
      "nonTiktok": "Hors TikTok",
      "tiktok": "TikTok",
      "total": "Total",
      "empty": "Aucune projection par cohorte disponible.",
      "drivers": {
        "title": "Facteurs de projection",
        "activeSellers": "Vendeurs actifs",
        "gmvPerSeller": "GMV par vendeur"
      }
    },
    "guidance": {
      "title": "Variante recommandée",
      "recommended": "Recommandé : {{variant}}",
      "none": "Aucune variante unique recommandée — consultez les vérifications ci-dessous.",
      "reasonsTitle": "Vérifications croisées",
      "variant": {
        "100pct": "Saisonnalité 100%",
        "50pct": "Amortie 50%",
        "25pct": "Amortie 25%"
      }
    },
    "halfYear": {
      "title": "Résumé semestriel",
      "subtitle": "Réel de l'année précédente, réel S1 courant, S2 projeté et année complète.",
      "empty": "Aucun résumé semestriel disponible.",
      "period": "Période",
      "actualBadge": "Réel",
      "projectedBadge": "Projeté",
      "columns": {
        "nonTiktok": "Hors TikTok",
        "tiktok": "TikTok",
        "total": "Total"
      }
    },
    "assumptionsTitle": "Hypothèses"
  },
  "export": {
    "button": "Exporter",
    "dialogTitle": "Exporter le rapport",
    "dialogDesc": "Choisissez un format de fichier. Le téléchargement démarrera lorsque le fichier sera prêt.",
    "formatLabel": "Format de fichier",
    "format": {
      "csv": "CSV",
      "xlsx": "Excel (XLSX)"
    },
    "cancel": "Annuler",
    "confirm": "Exporter",
    "working": "Préparation…",
    "progress": "Préparation de votre fichier… {{progress}} %",
    "started": "Exportation démarrée.",
    "ready": "Votre fichier est prêt. Téléchargement en cours.",
    "failed": "L'exportation a échoué. Veuillez réessayer.",
    "expired": "Cette exportation a expiré. Veuillez exporter à nouveau.",
    "failedTitle": "Échec de l'exportation",
    "pollFailedTitle": "Impossible de vérifier l'état de l'exportation"
  },
  "recompute": {
    "button": "Recalculer",
    "working": "Recalcul…",
    "confirmTitle": "Recalculer les analyses ?",
    "confirmDesc": "Cette action reconstruit toutes les analyses de zéro et peut prendre quelques minutes. Les données existantes restent visibles jusqu'à ce que les nouveaux résultats soient prêts.",
    "confirm": "Recalculer",
    "cancel": "Annuler",
    "started": "Recalcul démarré.",
    "alreadyRunning": "Un recalcul est déjà en cours",
    "alreadyRunningDesc": "Un recalcul est déjà en cours. Veuillez attendre la fin de son exécution.",
    "failedTitle": "Échec du recalcul"
  },
  "errors": {
    "generic": "Une erreur s'est produite.",
    "validation": "Certains filtres sont invalides. Veuillez vérifier et réessayer.",
    "unauthenticated": "Votre session a expiré. Veuillez vous reconnecter.",
    "forbidden": "Vous n'avez pas la permission de consulter ce rapport.",
    "invalidRange": "La plage de dates sélectionnée est invalide.",
    "network": "Erreur réseau. Veuillez réessayer."
  }
}
